export default "__VITE_ASSET__d86a9ab6__"